import { render } from "./movimentos-list-nova.vue?vue&type=template&id=6aa9bbb3"
import script from "./movimentos-list-nova.vue?vue&type=script&lang=js"
export * from "./movimentos-list-nova.vue?vue&type=script&lang=js"

import "./movimentos-list-nova.vue?vue&type=style&index=0&id=6aa9bbb3&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__